import { ReclamationView } from "src/api/generated/erp/db/types/tables/reclamationView";

export const getReclamationCustomerOrderLabel = (reclamation: ReclamationView) => {
	if (reclamation.customerOrderId != null) {
		return `${reclamation.customerOrderId} | ${reclamation.customerOrderReference}`;
	} else return "-";
};
